import { completeVerificationComplete } from '../store/app/action-creators';
import { codeVerificationSuccess } from '../store/step-code-verification/action-creators';
import { Tracker } from '../store/tracking/action-creators';
import { IdentityVerificationMethod } from '../tracking/IdentityVerificationMethod';
export const handleCodeVerificationSuccess = (response, dispatch) => {
  dispatch(codeVerificationSuccess());
  dispatch(completeVerificationComplete());
  dispatch(Tracker.verifyIdentityCompleted(IdentityVerificationMethod.CodeVerification));
};